import React from "react";
import { CDropdown, CDropdownToggle } from "@coreui/react";
import { connect } from "react-redux";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";

import { fetchUserPlacements } from "src/reducers/UserPlacementsReducer";

const TheHeaderDropdownTasks = ({ dispatch, isLoading }) => {
  return (
    <CDropdown inNav className="c-header-nav-item mx-2">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        {isLoading ? (
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <CIcon
            content={freeSet.cilReload}
            onClick={() => {
              dispatch(fetchUserPlacements);
            }}
          />
        )}
      </CDropdownToggle>
    </CDropdown>
  );
};

function mapStateToProps(state) {
  return {
    isLoading: state.userPlacementsReducer.isLoading,
  };
}

export default connect(mapStateToProps)(TheHeaderDropdownTasks);
